const getFooterYear = () => {
  return new Promise((resolve, reject) => {
    const $ = window.$;

    const STORAGE_NAME = '__PUBLIC_MECHA_FOOTER__YEAR';

    /**
     * 是否支持LocalStorage
     */
    function isLocalStorageSupported() {
      return typeof localStorage !== 'undefined';
    }

    /**
     * 从客户端获取年份
     */
    function getCurrentYearFromClient() {
      return new Date().getFullYear();
    }

    /**
     * 通过 Storage 获取年份
     * @returns {null}
     */
    function getYearFromStorage() {
      try {
        if (isLocalStorageSupported()) {
          return localStorage.getItem(STORAGE_NAME);
        }
      } catch (e) {
        // 当localStorage异常，如：满载等情况， 容错处理
      }
      return null;
    }

    /**
     * 将Year保存到Storage中
     * @param year
     */
    function saveYear2Storage(year) {
      try {
        if (isLocalStorageSupported()) {
          localStorage.setItem(STORAGE_NAME, year);
          return true;
        }
      } catch (e) {
        // 当localStorage异常，如：满载等情况， 容错处理
      }
      return false;
    }

    /**
     * 更新copy right时间
     */
    function updateCopyRightTime() {
      /**
       * 页面所有内容加载完成后
       */
      getCopyRightTimeFromServer(function(year) {
        if (year) {
          // 加入缓存
          saveYear2Storage(year);
          resolve(year);
        }
      });
    }

    /**
     * 获取
     * @param callback
     */
    const getCopyRightTimeFromServer = function(callback) {
      try {
        $.ajax({
          type: 'HEAD',
          url: window.location.href,
          complete: function complete(xhr) {
            const hinfo = {
              date: xhr.getResponseHeader('Date')
            };
            const GMT = 8; // 时区
            const month = {
              Jan: '01',
              Feb: '02',
              Mar: '03',
              Apr: '04',
              May: '05',
              Jun: '06',
              Jul: '07',
              Aug: '08',
              Sep: '09',
              Oct: '10',
              Nov: '11',
              Dec: '12'
            };
            // 格式化当前时间
            let times = hinfo.date.split(',')[1].split(' ');
            times[4] = times[4].split(':');
            times[4][0] = (parseInt(times[4][0], 10) + GMT).toString();
            times[4] = times[4].join(':');
            times = times[3] + '/' + month[times[2]] + '/' + times[1] + ' ' + times[4];
            const mtimesecs = new Date(times).getTime(); // 获取当前毫秒数
            // 时钟函数
            const date = new Date(mtimesecs); // 获取日期时间对象
            const year = date.getFullYear();
            callback(year);
          }
        });
      } catch (e) {
        resolve(clientCurrentYear);
        console.error(e);
      }
    };

    const clientCurrentYear = getCurrentYearFromClient();
    // 缓存年份
    const storageYear = +getYearFromStorage();

    /**
     * 当缓存的年份和客户端的年份不匹配的时候 获取服务端的年份
     */
    if (clientCurrentYear !== storageYear) {
      updateCopyRightTime();
    } else {
      resolve(storageYear);
    }
  });
};
export default getFooterYear;
